// extracted by mini-css-extract-plugin
module.exports = {"root":"booking-card_root__2Fjva"};